import React from 'react'
import {useSelector} from 'react-redux'
import moment from 'moment'
import {makeStyles} from '@mui/styles'
import Grid from '@mui/material/Grid'
import {Colors} from '../../assets/styles'
import {selectLoggedActionFromNudgeActions} from '../../reducers/selectors'
import {BUILDING_ACTION_TYPE_LABELS, buildingActionTypeToCategoryLabel, BUILDING_NUDGE_TYPE_LABELS} from './AssistantConstants'
import useResidentLookup from '../hooks/useResidentLookup'
import ImageGallerySelector from '../ImageGallerySelector'

const useStyles = makeStyles(theme => ({
  container: {
    flexGrow: 1,
    marginBottom: 22,
  },
  infoTitle: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: Colors.rxrSecondaryPrimaryGrayColor,
  },
  infoData: {
    fontSize: 16,
    lineHeight: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: Colors.rxrPrimaryColor,
    paddingTop: '12px',
  },
}))

export default function ViewLogActionForm(props) {
  const classes = useStyles()

  const loggedAction = useSelector(state => selectLoggedActionFromNudgeActions(state, props.actionId))
  const {getResident} = useResidentLookup()

  if (!loggedAction) {
    return null
  }

  /**
   * Common function for rendeing data point.
   * @param {*} title
   * @param {*} data
   * @returns {string}
   */
  const renderInfo = (title, data) => (
    <Grid container direction="column">
      <Grid item>
        <div className={classes.infoTitle}>{title}</div>
      </Grid>
      <Grid item>
        <div className={classes.infoData}>{data ? data : '--'}</div>
      </Grid>
    </Grid>
  )

  const getResidentNameAndUnit = residentId => {
    let resident = getResident(residentId)

    let residentName = resident.displayName
    let unit = resident.occupancy.unit.number
    return `${residentName}, ${unit}`
  }

  const getCategoriesAndActions = actions => {
    if (!actions) {
      return null
    }

    let categoryToActionsObj = actions.reduce((agr, a) => {
      let categoryLabel = buildingActionTypeToCategoryLabel(a)
      if (!agr[categoryLabel]) {
        agr[categoryLabel] = []
      }
      agr[categoryLabel].push(BUILDING_ACTION_TYPE_LABELS[a])
      return agr
    }, {})

    return (
      <ul>
        {Object.entries(categoryToActionsObj).map(([categoryLabel, actionLabels], index) => (
          <li key={index}>
            {categoryLabel}: {actionLabels.join(', ')}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <div className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {renderInfo('Name', getResidentNameAndUnit(loggedAction.residentId))}
        </Grid>
        <Grid item xs={12}>
          {renderInfo('Category & action', getCategoriesAndActions(loggedAction.actions))}
        </Grid>
        <Grid item xs={12}>
          {renderInfo('Date action was taken', moment(loggedAction.actionTakenAt).format('MM/DD/YY'))}
        </Grid>
        <Grid item xs={12}>
          {renderInfo('Date and time the action was logged', moment(loggedAction.createdAt).format('MM/DD/YY, h:mma'))}
        </Grid>
        <Grid item xs={12}>
          {renderInfo('Total price', `$${loggedAction.cost ? loggedAction.cost : 0}`)}
        </Grid>
        <Grid item xs={12}>
          {renderInfo('Reason', BUILDING_NUDGE_TYPE_LABELS[loggedAction.reason] || loggedAction.reason)}
        </Grid>
        <Grid item xs={12}>
          {renderInfo('Notes', loggedAction.notes)}
        </Grid>
        {loggedAction.attachments && loggedAction.attachments.length > 0 && (
          <Grid item xs={12}>
            <div className={classes.infoTitle}>Attachments</div>
            <div className={classes.infoData}>
              <ImageGallerySelector
                maxPhotos={1}
                value={loggedAction.attachments}
                onChange={() => {}} // Read-only mode
                isViewOnly={true}
              />
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  )
}
